import { firstCharLowercase } from '@/assets/scripts/strings'
import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns holder data
@return { Array }
*/
export const getHolderData = state => state.holder

/** returns Accounts Balances
@return { Array }
*/
export const getDomainData = state => domainName => state[firstCharLowercase(domainName.replace(/\s/g, ''))]

/** returns Quotation data
@return { Array }
*/
export const getSimulationData = state => state.quotation

/** returns Documents
@return { Array }
*/
export const getDocuments = state => state.documents
